import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-soc-l1-mall-plan",
  "use": "icon-soc-l1-mall-plan-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-soc-l1-mall-plan\">\r\n<g transform=\"translate(-80 -80) scale(1.18)\">\r\n  <path d=\"M192 192h640v640H192V192zm64 64v512h512V256H256zm96 96h320v48H352v-48zm0 96h320v48H352v-48zm0 96h224v48H352v-48zm0 96h160v48H352v-48z\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/soc-l1-mall-plan.svg
// module id = bj/2
// module chunks = 488